import { useContext } from "react";

import ChatContext, { IChatContext } from "@app/util/contexts/ChatContext";

const useShouldKeepChatHidden = (): boolean => useContext<IChatContext>(ChatContext);

export default useShouldKeepChatHidden;
